<ng-container *ngIf="(state$ | async) as state">
  <ng-container *ngIf="state.advertise as advertise">
    <div class="mb-2" ga-event="advertise-click|seeker|{{advertise.Title || advertise.Id}}">
      <a *ngIf="external" class="f-default-link" [innerHTML]="advertise.Banner" [href]="advertise.Link" target="_blank"
        rel="noopener noreferrer" [attr.ga-event]="'advertise-click|seeker|'+(advertise.Title || advertise.Id)"
        [attr.ga-label]="advertise.Link">
      </a>
      <a *ngIf="!external" class="f-default-link" [innerHTML]="advertise.Banner"
        [routerLink]="advertise.Link || ['/exclusive-job',advertise.Id]"
        [queryParams]="advertise.Link && advertise.SetLinkUtm ? {utm_source:'karpishe', utm_medium: 'job-ads'} : undefined"></a>
    </div>
  </ng-container>

  <ng-container *ngIf="!state?.advertise">
    <app-questioner class="mb-2" [search-params]="appliedParams" (question-key)="onQuestion?.emit($event)">
    </app-questioner>
  </ng-container>
</ng-container>